import { ReactNode } from 'react';
import { OfficeProvider } from 'src/features/plugins/outlook/contexts/OfficeContext';
import { DialogProvider } from 'src/features/plugins/outlook/contexts/DialogContext';

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <OfficeProvider>
      <DialogProvider>{children}</DialogProvider>
    </OfficeProvider>
  );
}
